import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';

const tourActivityAPI = createApi({
    reducerPath: "tourActivityAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllTourActivities: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `activities/get-all?page=${page}&size=${size}`;

                if (key) {
                    apiUrl += `&searchKey=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["tour_activity"],
        }),
        getTourActivityByID: builder.mutation({
            query: ({id}) => ({
                url: `activities/get/by-id/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        createTourActivity: builder.mutation({
            query: ({ body }) => ({
                url: `activities/create`,
                method: "POST",
                body
            }),
            invalidatesTags: ["tour_activity"]
        }),
        updateTourActivity: builder.mutation({
            query: ({ body }) => {
                const apiUrl = `activities/update`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body
                };
            },
            transformResponse: (response) => response,
            invalidatesTags: ["tour_activity"]
        }),
        deleteTourActivity: builder.mutation({
            query: ({id}) => ({
                url: `activities/delete/${id}`,
                method: "DELETE",
                body:{}
            }),
            invalidatesTags: ["tour_activity"],
        })
    })
});

export const { 
    useGetAllTourActivitiesMutation,
    useGetTourActivityByIDMutation,
    useCreateTourActivityMutation,
    useUpdateTourActivityMutation,
    useDeleteTourActivityMutation
} = tourActivityAPI;

export default tourActivityAPI;